import React from 'react';

import { FastshiftRunbook } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { FormattedMessage } from 'react-intl';

import { Stack } from '@atlaskit/primitives';

import { messages } from '../messages';
import { RunbookStepList } from '../runbook-step/runbook-step-list';

import { RunbookDateMetadata, RunbookProductMetadata } from './runbook-metadata';

export type RunbookDetailContentProps = {
	runbook: FastshiftRunbook;
	supportTicketId: string;
};

export const RunbookDetailContent: React.FC<RunbookDetailContentProps> = ({
	runbook,
	supportTicketId,
}) => (
	<Stack space="space.200">
		<Stack space="space.050">
			<RunbookProductMetadata product={runbook.product} />
			{runbook.dueDate && (
				<RunbookDateMetadata
					label={<FormattedMessage {...messages.runbooksPanelNextReviewLabel} />}
					value={runbook.dueDate}
				/>
			)}
		</Stack>
		<RunbookStepList
			steps={runbook.steps}
			supportTicketId={supportTicketId}
			runbookId={runbook.runbookId}
		/>
	</Stack>
);
